
<div id="login">
    <div class="imagery" style="background-image:url(assets/images/road-1.jpg);"></div>
    <div class="dialogue">
        <div class="panel">
            <div class="titleBar">
                <svg class="icon"><use xlink:href="assets/iconography/symbol-defs.svg#icon-user"></use></svg>
                <div class="title">Logging you in...</div>
            </div>
            <img class="logo" src="assets/images/logo.png" alt="MTData">
            <div class="product-name">EWD Central Server</div>
            <div class="product-version">v{{version}}</div>
            <div class="lineBreak"></div>
        </div>
    </div>

</div>
